import { render, staticRenderFns } from "./GovServices.vue?vue&type=template&id=dc7eae10&"
import script from "./GovServices.vue?vue&type=script&lang=js&"
export * from "./GovServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports